import { MAIN_URL, REQUEST_URL } from "../../constant/ApplicationVariables";
import useAxios, { axiosInstance } from "../useAxios/useAxios";

// ============================================================
// EXISTING LICENSE APIS - DO NOT MODIFY
// ============================================================

export const getLicenseList_API = async (query) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.licensePlan + `${query ? `?${query}` : ``}`,
            method: "GET",
            contentType: "application/json"
        });
        console.log(response, "getLicenseList response");
        return response
    } catch (error) {
        console.log(error, "getLicenseList error");
        return error;
    }
}

export const createLicense_API = async (body) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.licensePlan,
            method: "POST",
            data: body,
            contentType: "application/json"
        });
        console.log(response, "createLicense response");
        return response
    } catch (error) {
        console.log(error, "createLicense error");
        return error;
    }
}

export const updateLicense_API = async (body) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.licensePlan,
            method: "PUT",
            data: body,
            contentType: "application/json"
        });
        console.log(response, "updateLicense response");
        return response
    } catch (error) {
        console.log(error, "updateLicense error");
        return error;
    }
}

export const deleteLicense_API = async (query) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.licensePlan + `${query ? `${query}` : ``}`,
            method: "DELETE",
            contentType: "application/json"
        });
        console.log(response, "deleteLicense response");
        return response
    } catch (error) {
        console.log(error, "deleteLicense error");
        return error;
    }
}

export const subscribeLicensePlan_API = async (body) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.subscription,
            method: "POST",
            data: body,
            contentType: "application/json"
        });
        console.log(response, "subscribeLicensePlan response");
        return response
    } catch (error) {
        console.log(error, "subscribeLicensePlan error");
        return error;
    }
}

export const getLicensePlanSubscriptionDetail_API = async (query) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.subscription + `${query ? `?${query}` : ``}`,
            method: "GET",
            contentType: "application/json"
        });
        console.log(response, "getLicensePlanSubscriptionDetail response");
        return response
    } catch (error) {
        console.log(error, "getLicensePlanSubscriptionDetail error");
        return error;
    }
}

export const deleteLicensePlanSubscription_API = async (query) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.subscription + `${query ? `?${query}` : ``}`,
            method: "DELETE",
            contentType: "application/json"
        });
        console.log(response, "deleteLicensePlanSubscription response");
        return response
    } catch (error) {
        console.log(error, "deleteLicensePlanSubscription error");
        return error;
    }
}

export const getLicensePlanSubscriptionInvoices_API = async (query) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.subscriptionInvoices + `${query ? `?${query}` : ``}`,
            method: "GET",
            contentType: "application/json"
        });
        console.log(response, "getLicensePlanSubscriptionInvoices response");
        return response
    } catch (error) {
        console.log(error, "getLicensePlanSubscriptionInvoices error");
        return error;
    }
}

export const getLicenseAddOnList_API = async (query) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.licenseAddOn + `${query ? `?${query}` : ``}`,
            method: "GET",
            contentType: "application/json"
        });
        console.log(response, "getLicenseAddOnList response");
        return response
    } catch (error) {
        console.log(error, "getLicenseAddOnList error");
        return error;
    }
}

export const createLicenseAddOn_API = async (body) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.licenseAddOn,
            method: "POST",
            data: body,
            contentType: "application/json"
        });
        console.log(response, "createLicenseAddOn response");
        return response
    } catch (error) {
        console.log(error, "createLicenseAddOn error");
        return error;
    }
}

export const updateLicenseAddOn_API = async (body) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.licenseAddOn,
            method: "PUT",
            data: body,
            contentType: "application/json"
        });
        console.log(response, "updateLicenseAddOn response");
        return response
    } catch (error) {
        console.log(error, "updateLicenseAddOn error");
        return error;
    }
}

export const deleteLicenseAddOn_API = async (query) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.licenseAddOn + `${query ? `${query}` : ``}`,
            method: "DELETE",
            contentType: "application/json"
        });
        console.log(response, "deleteLicenseAddOn response");
        return response
    } catch (error) {
        console.log(error, "deleteLicenseAddOn error");
        return error;
    }
}

// ============================================================
// SUPER ADMIN - STANDALONE LICENSE APIS (NEW)
// ============================================================

/**
 * Get all organisations for Super Admin
 * GET /admin/company
 */
export const getOrganisationList_API = async () => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.organisation,
            method: "GET",
            contentType: "application/json"
        });
        return response;
    } catch (error) {
        console.log(error, "getOrganisationList error");
        return error;
    }
}

/**
 * Get standalone licenses for an organisation
 * GET /admin/licenses?companyId={id}
 */
export const getStandaloneLicenseList_API = async (query) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.standaloneLicense + `${query ? `?${query}` : ``}`,
            method: "GET",
            contentType: "application/json"
        });
        return response;
    } catch (error) {
        console.log(error, "getStandaloneLicenseList error");
        return error;
    }
}

/**
 * Create a new standalone license
 * POST /admin/licenses
 */
export const createStandaloneLicense_API = async (body) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.standaloneLicense,
            method: "POST",
            data: body,
            contentType: "application/json"
        });
        return response;
    } catch (error) {
        console.log(error, "createStandaloneLicense error");
        return error;
    }
}

/**
 * Update a standalone license
 * PUT /admin/licenses/{licenseNo}
 */
export const updateStandaloneLicense_API = async (licenseNo, body) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.standaloneLicense + `/${licenseNo}`,
            method: "PUT",
            data: body,
            contentType: "application/json"
        });
        return response;
    } catch (error) {
        console.log(error, "updateStandaloneLicense error");
        return error;
    }
}

/**
 * Revoke a standalone license
 * POST /admin/licenses/{licenseNo}/revoke
 */
export const revokeStandaloneLicense_API = async (licenseNo) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.standaloneLicense + `/${licenseNo}/revoke`,
            method: "POST",
            contentType: "application/json"
        });
        return response;
    } catch (error) {
        console.log(error, "revokeStandaloneLicense error");
        return error;
    }
}

/**
 * Reactivate a revoked standalone license
 * POST /admin/licenses/{licenseNo}/reactivate
 */
export const reactivateStandaloneLicense_API = async (licenseNo) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.standaloneLicense + `/${licenseNo}/reactivate`,
            method: "POST",
            contentType: "application/json"
        });
        return response;
    } catch (error) {
        console.log(error, "reactivateStandaloneLicense error");
        return error;
    }
}

/**
 * Delete a standalone license
 * DELETE /admin/licenses/{licenseNo}
 */
export const deleteStandaloneLicense_API = async (licenseNo) => {
    try {
        const response = await axiosInstance({
            url: MAIN_URL.url + REQUEST_URL.standaloneLicense + `/${licenseNo}`,
            method: "DELETE",
            contentType: "application/json"
        });
        return response;
    } catch (error) {
        console.log(error, "deleteStandaloneLicense error");
        return error;
    }
}